(function () {
  var _originalFetch = window.fetch;

  window.fetch = function (url, options) {
    var fetchPromise = _originalFetch.apply(this, arguments);

    var urlString = typeof url === 'string' ? url : (url && url.url) || '';
    if (urlString.indexOf('/cart/add') !== -1) {
      fetchPromise.then(function (response) {
        return response.clone().json();
      }).then(function (data) {
        if (data.status === 422 || data.status === 400) return;

        if (data.items && Array.isArray(data.items)) {
          data.items.forEach(function (item) { _trackItem(item); });
        } else if (data.id) {
          _trackItem(data);
        }
      }).catch(function () {});
    }

    return fetchPromise;
  };

  function _trackItem(item) {
    if (!window.klaviyo || !window.slyLocale) return;

    var price = item.price ? (item.price / 100).toFixed(2) : '';

    window.klaviyo.track('Added to Cart', {
      Language: window.slyLocale,
      ProductID: String(item.product_id || ''),
      VariantID: String(item.id || item.variant_id || ''),
      ProductName: item.product_title || item.title || '',
      SKU: item.sku || '',
      Price: price,
      URL: window.location.href
    });
  }
})();
